import { lighten } from 'polished';
import { Grid, Column, Title, SubTitle } from '@bidalihq/ui';
import Image from 'next/image';

import { colors } from '@/themes';
import Section from '@/components/section';

const Hero = () => {
  return (
    <Section backgroundColor={lighten(.35, colors.brand.primary)}>
      <Grid columns={[1, 3]}>
        <Column span={[1, 2]}>
          <Title className="text-brand-primary">Careers at Bidali</Title>
          <SubTitle>You can change the way world does business.</SubTitle>
        </Column>
        <Column span={1}>
          <Image className="rounded-2xl" height={366} src="/images/shop-sign.jpg" width={550} alt="Open Sign" />
        </Column>
      </Grid>
    </Section>
  );
};

export default Hero;
